if (!customElements.get('image-text-slider')) {
  class ImageTextSlider extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.timer = null;
      this.isHovered = false;
    }

    connectedCallback() {
      this.images = Array.from(this.querySelectorAll('.image-text-slider__image'));
      this.texts = Array.from(this.querySelectorAll('.image-text-slider__text'));
      this.content = this.querySelector('.image-text-slider__content');
      this.prevButton = this.querySelector('[data-slider-prev]');
      this.nextButton = this.querySelector('[data-slider-next]');

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.show(this.currentIndex - 1);
          this.restartAutoplay();
        });
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.show(this.currentIndex + 1);
          this.restartAutoplay();
        });
      }

      const canHover = window.matchMedia('(hover: hover)').matches;
      if (this.dataset.pauseOnHover === 'true' && this.content && canHover) {
        this.content.addEventListener('mouseenter', () => {
          this.isHovered = true;
          this.stopAutoplay();
        });
        this.content.addEventListener('mouseleave', () => {
          this.isHovered = false;
          this.startAutoplay();
        });
      }

      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    show(index) {
      const total = this.images.length;
      if (!total) return;
      this.currentIndex = (index + total) % total;
      this.images.forEach((image, i) => image.classList.toggle('is-active', i === this.currentIndex));
      this.texts.forEach((text, i) => text.classList.toggle('is-active', i === this.currentIndex));
    }

    startAutoplay() {
      if (this.dataset.autoplay !== 'true' || this.images.length < 2) return;
      if (this.isHovered || this.timer) return;
      const speed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
      this.timer = setInterval(() => this.show(this.currentIndex + 1), speed);
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  customElements.define('image-text-slider', ImageTextSlider);
}